<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconCar1"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="24">
        <circle cx="16.8" cy="20" r="4"/>
        <circle cx="26.8" cy="20" r="4"/>
        <circle cx="65.7" cy="20" r="4"/>
        <path
            d="M71.7 0h-13l-1 9H57V0l-2 3v3H0v6h4v1h3v2h4v2H7v1h4.9s1.8-3 5-3 4 3 4 3h2s.4-2.6 3.4-3H27.7c.1 0 .3 0 .4.1.1 0 .2 0 .3.1.1 0 .2.1.4.1.1 0 .2 0 .2.1.1 0 .2.1.3.2.1 0 .1.1.2.1.1.1.2.1.3.2.1 0 .1.1.2.1.1.1.2.1.2.2.1 0 .1.1.2.1l.2.2.2.2.2.2c0 .1.1.1.1.2s.1.1.1.2.1.1.1.2.1.1.1.2.1.1.1.2 0 .1.1.2c0 .1.1.1.1.2 0 0 0 .1.1.1 0 .1 0 .1.1.2v.1c0 .1 0 .1.1.2v.2s.1 0 .1.1c-.2-.2-.1-.2-.1-.2v1h29v-1s-.1-.1-.1-.4c.2-1 1.2-3.6 4.8-3.6h.7c.1 0 .2 0 .3.1.1 0 .3 0 .4.1.1 0 .1 0 .2.1.1 0 .3.1.4.1.1 0 .1.1.2.1.1.1.3.1.4.2 0 0 .1 0 .1.1.1.1.3.2.4.2h.2c1.5 1.2 2.1 3 2.1 3v1h2.7s2.3-.3 2.3-1V7l-4.4-7"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
